import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChargingStation: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChargingStation"><Path d="M9.21429 6.28577L6 10.2143H7.78571V12.7143L11 8.78577H9.21429V6.28577Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H14V19H21V21H3V3ZM5 5V14H12V5H5Z" fill="currentColor"/><Path d="M21 6.53158L16.872 3.09155L15.5916 4.628L19 7.46833V15H18V9.99996H16V17H21V6.53158Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChargingStation;
